import { render, staticRenderFns } from "./LifeLinePlate.vue?vue&type=template&id=67ba2cd9&lang=pug&"
import script from "./LifeLinePlate.vue?vue&type=script&lang=ts&"
export * from "./LifeLinePlate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports